import { Box, BoxProps, forwardRef } from '@chakra-ui/react';

import { createUseVariantStyle } from '@bonusly/ds-hooks';

export type DisplaySize = '2xs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export interface DisplayProps extends BoxProps {
	size?: DisplaySize;
}

const useVariantStyle = createUseVariantStyle({
	size: {
		'2xs': {
			fontSize: 200,
		},
		xs: {
			fontSize: 300,
		},
		sm: {
			fontSize: 500,
		},
		md: {
			fontSize: 600,
		},
		lg: {
			fontSize: 800,
		},
		xl: {
			fontSize: 900,
		},
	},
});

const Display = forwardRef(({ size = 'md', ...rest }: DisplayProps, ref) => {
	const styles = useVariantStyle({ size });

	return <Box as="h1" fontFamily="display" fontWeight="extrabold" letterSpacing="display" lineHeight="short" ref={ref} {...styles} {...rest} />;
});

Display.displayName = 'Display';

export { Display };
